module.exports = __webpack_public_path__ + "static/media/excel.d54f4dd2.svg";